// Helpers for computing upcoming show air dates anchored to America/New_York.

function etDateInfo(date) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    weekday: 'long',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date);
  const get = (ty) => parts.find((p) => p.type === ty).value;
  return {
    weekday: get('weekday').toLowerCase(),
    iso: `${get('year')}-${get('month')}-${get('day')}`,
  };
}

// Next `count` air dates (YYYY-MM-DD, ET) for a show based on its days + start_time.
export function getNextAirDates(show, count = 4, now = new Date()) {
  const days = show?.days || [];
  if (!days.length) return [];
  const out = [];
  for (let offset = 0; offset < 60 && out.length < count; offset++) {
    const d = new Date(now.getTime() + offset * 86400000);
    const info = etDateInfo(d);
    if (days.includes(info.weekday)) out.push({ iso: info.iso, weekday: info.weekday });
  }
  return out;
}

export function formatAirDate(iso) {
  const [y, m, d] = iso.split('-').map(Number);
  // ~noon ET keeps the calendar date stable regardless of DST.
  const dt = new Date(Date.UTC(y, m - 1, d, 16));
  return new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  }).format(dt);
}

// Build a JS Date representing an ET wall-clock instant (calendar date + HH:MM),
// trying both standard and daylight offsets so DST is handled correctly.
function etWallInstant(iso, time) {
  const [y, m, d] = iso.split('-').map(Number);
  const [hh, mm] = (time || '00:00').split(':').map(Number);
  for (const offset of [-4, -5]) {
    const candidate = new Date(Date.UTC(y, m - 1, d, hh - offset, mm));
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).formatToParts(candidate);
    const ch = parseInt(parts.find((p) => p.type === 'hour').value, 10);
    const cm = parseInt(parts.find((p) => p.type === 'minute').value, 10);
    const chAdj = ch === 24 ? 0 : ch;
    if (chAdj === hh && cm === mm) return candidate;
  }
  return new Date(Date.UTC(y, m - 1, d, hh + 4, mm));
}

// "Due by" = 24h before the show start. Returns a formatted ET datetime string.
export function dueByDateTime(show, airIso) {
  const start = etWallInstant(airIso, show.start_time);
  const due = new Date(start.getTime() - 24 * 3600 * 1000);
  return (
    new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    }).format(due) + ' ET'
  );
}